module.exports = "<span tabindex=\"0\" (click)=\"params.data.defaultAction='view'\">{{params.data.Link}}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/resource-url/resource-url.component.html
// module id = ./src/app/resource-url/resource-url.component.html
// module chunks = main